import React, { useEffect } from "react"
import PropTypes from "prop-types"
import Modal, { Action } from "@kit/design/modal"
import { useMediaBreakpoint } from "@kit/design/use-media-breakpoint"
import { PaymentForm } from "../../../onboarding/payment-form"
import analytics from "utils/analytics"

export function AddCardModal({
  title = "",
  onClose,
  paymentFormOptions,
  tracking = {}
}) {
  const { feature, location, plan = "creator" } = tracking

  useEffect(() => {
    analytics.track("Element", "Opened", {
      element_type: "modal",
      name: "payment_form",
      title: title,
      feature: feature,
      location: location,
      plan: plan
    })
  }, [feature, location, plan, title])

  const lg = useMediaBreakpoint("lg")

  return (
    <Modal label={title} onClose={onClose} data-testid="add-card-modal">
      <div className="mb-10 mt-5">
        <PaymentForm {...paymentFormOptions} />
        {lg || paymentFormOptions.modalOptions ? null : (
          <Action is="secondary" onClick={onClose}>
            Cancel
          </Action>
        )}
      </div>
    </Modal>
  )
}

AddCardModal.propTypes = {
  title: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  paymentFormOptions: PropTypes.shape({
    handleSubscription: PropTypes.func.isRequired,
    plans: PropTypes.array,
    billingCycle: PropTypes.oneOf(["month", "year"]),
    onPlanChange: PropTypes.func,
    modalOptions: PropTypes.shape({
      handleClose: PropTypes.func
    })
  }),
  tracking: PropTypes.shape({
    feature: PropTypes.string,
    location: PropTypes.string,
    plan: PropTypes.string
  })
}
